import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from 'react';
import jwtDecode from 'jwt-decode';
import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import AuthContext from '@cpg-its/ads.auth.auth-context';
export const AuthHelperComponent = ({ children, }) => {
    const [accessToken, setAccessToken] = useState(null);
    const [decodedToken, setDecodedToken] = useState(null);
    const [tokenError, setTokenError] = useState(null);
    const { isAuthenticated, loginWithRedirect, logout, getAccessTokenSilently, isLoading, error, } = useAuth0();
    const getAccessToken = useCallback(async (cacheMode = 'on') => {
        try {
            setAccessToken(await getAccessTokenSilently({
                cacheMode: ['on', 'off', 'cache-only'].includes(cacheMode) ?
                    cacheMode :
                    'on',
            }));
        }
        catch (e) {
            if (e instanceof Error) {
                // eslint-disable-next-line no-console
                console.log(e.message);
                setTokenError(e.message);
            }
            else {
                // Handle the case where e is not an Error
                console.log('An unknown error occurred.');
                setTokenError('An unknown error occurred while fetching the access token.');
            }
        }
        return '';
    }, [getAccessTokenSilently]);
    useEffect(() => {
        if (isAuthenticated) {
            getAccessToken();
        }
    }, [isAuthenticated, getAccessToken]);
    useEffect(() => {
        if (isAuthenticated && accessToken) {
            setDecodedToken(jwtDecode(accessToken));
        }
    }, [isAuthenticated, accessToken]);
    const values = useMemo(() => ({
        error,
        isLoading,
        logout,
        loginWithRedirect,
        isAuthenticated,
        getAccessToken,
        accessToken,
        decodedToken,
        tokenError,
        withAuthenticationRequired,
    }), [error,
        isLoading,
        logout,
        loginWithRedirect,
        isAuthenticated,
        getAccessToken,
        accessToken,
        decodedToken,
        tokenError,
    ]);
    return (_jsx(AuthContext.Provider, { value: values, children: children }));
};
export default AuthHelperComponent;
//# sourceMappingURL=auth-helper.js.map